import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/features/services/users/Auth/auth.service';
declare let window: any;

@Injectable({
  providedIn: 'root',
})

export class AppInitService {

  constructor(
    private authService: AuthService
  ) { }

  public init() {
    return from(
      fetch('assets/app-config.json').then(function (response) {
        return response.json();
      })
    ).pipe(
      switchMap((config) => {
        window.config = config.apiUrl;
        window.apiV3Url = config.apiV3Url;
        window.env = config.environment;
        window.aiAlertApiUrl = config.aiAlertApiUrl;
        window.aiAlertChatApiUrl = config.aiAlertChatApiUrl;
        window.adaChatUrl = config.adaChatUrl;
        window.kb_wp_ApiUrl = config.kb_wp_ApiUrl;
        window.kb_domain_ApiUrl = config.kb_domain_ApiUrl;
        window.classicUiUrl = config.classicUiUrl;
        window.uiTransitionEndDate = config.uiTransitionEndDate;
        window.hubspotToken = config.hubspotToken;
        return new Observable<void>((observer) => {
          this.authService.getUserByToken().subscribe({
            next: () => {
              // Do something if needed
            },
            error: () => {
              observer.next();  // or observer.error(err) if you want to stop bootstrap
              observer.complete();
            },
            complete: () => {
              observer.next();
              observer.complete();
            }
          });
        });
      }));
  }
}
